import { defineStore } from 'pinia'

const getExternalConfigCompanyIdStorage = () => {
    if (typeof window === 'undefined') return null

    const companyId = sessionStorage.getItem('externalConfigCompanyId')
    return companyId ? Number(companyId) : null
}

export const useNavigationStore = defineStore('navigation', {
    state: () => ({
        cameFromUsers: false,
        externalConfigCompanyId: getExternalConfigCompanyIdStorage(),
    }),

    actions: {
        setCameFromUsers(value) {
            this.cameFromUsers = value
        },

        setExternalConfigCompanyId(companyId) {
            const id = companyId ? Number(companyId) : null

            this.externalConfigCompanyId = id

            if (typeof window !== 'undefined') {
                if (id) {
                    sessionStorage.setItem('externalConfigCompanyId', String(id))
                } else {
                    sessionStorage.removeItem('externalConfigCompanyId')
                }
            }
        },

        clearExternalConfigCompanyId() {
            this.externalConfigCompanyId = null

            if (typeof window !== 'undefined') {
                sessionStorage.removeItem('externalConfigCompanyId')
            }
        },
    },
})